import React from 'react';
import api from '../../../../Api';

export default function useSocialNetworkShareUris(sku) {
	const socialNetwork = {
		uri: '',
		isLoading: true,
		error: { exists: false, value: {} },
	};

	const [twitter, setTwitter] = React.useState(socialNetwork);
	const [facebook, setFacebook] = React.useState(socialNetwork);

	React.useEffect(() => {
		let request;

		const fetchSocialNetworkShareUri = async (
			endpoint,
			setSocialNetwork,
		) => {
			request = api.cancelableGet(endpoint);

			try {
				const uri = await request.promise;
				setSocialNetwork(sn => ({ ...sn, uri, isLoading: false }));
			} catch (err) {
				const error = { exists: true, value: err };
				setSocialNetwork(sn => ({ ...sn, error, isLoading: false }));
			}
		};

		const fetchFacebookShareUri = () => {
			const endpoint = `/api/me/reviews/products/${sku}/share-uri/facebook`;
			return fetchSocialNetworkShareUri(endpoint, setFacebook);
		};

		const fetchTwitterShareUri = () => {
			const endpoint = `/api/me/reviews/products/${sku}/share-uri/twitter`;
			return fetchSocialNetworkShareUri(endpoint, setTwitter);
		};

		const initialize = async () => {
			await fetchFacebookShareUri();
			await fetchTwitterShareUri();
		};

		initialize();

		return () => {
			api.revoke(request);
		};
	}, [sku]);

	return {
		twitter: { ...twitter, displayName: 'Twitter' },
		facebook: { ...facebook, displayName: 'Facebook' },
	};
}
